import React from 'react';
import { LayoutContext } from '../../shared/hooks/useLayoutContext';

interface ImmersiveLayoutProps {
  children: React.ReactNode;
}

const ImmersiveLayout: React.FC<ImmersiveLayoutProps> = ({ children }) => {
  return (
    <LayoutContext.Provider value={{ layoutType: 'immersive' }}>
      <div
        style={{
          width: '100vw',
          height: '100vh',
          overflow: 'hidden',
          position: 'relative',
          isolation: 'isolate',
        }}
      >
        {children}
      </div>
    </LayoutContext.Provider>
  );
};

export default ImmersiveLayout;
